import store from 'store/Store';
import OrderActions from 'actions/OrderActions';
import historyLocationActions from 'actions/framework/HistoryLocationActions';
import checkoutUtils from 'utils/Checkout';
import Actions from 'Actions';
import { PAYMENT_CARD_NUMBER_CHANGED, GIFT_CARD_APPLIED, TOGGLE_CVC_INFO_MODAL } from 'constants/actionTypes/order';

const CHECKOUT_SECTIONS = checkoutUtils.CHECKOUT_SECTIONS;
const CHECKOUT_PATH = checkoutUtils.CHECKOUT_PATH;

const resetAccessPoint = () => {
    store.dispatch(OrderActions.removeHalAddress());
    store.dispatch(OrderActions.togglePlaceOrderDisabled(true));
};

const changeRoute = checkoutPath => {
    const path = `${CHECKOUT_PATH}/${checkoutPath}`;
    store.dispatch(historyLocationActions.goTo({ path }));
    store.dispatch(OrderActions.togglePlaceOrderDisabled(true));
};

const createDraftHalAddress = (address, shippingGroupId, halOperatingHours, callback) => {
    store.dispatch(OrderActions.createDraftHalAddress(address, shippingGroupId, halOperatingHours)).then(() => {
        changeRoute(CHECKOUT_SECTIONS.SHIP_ADDRESS.path);

        if (callback) {
            callback();
        }
    });
};

const showPlaceOrderTermsModal = (isOpen, arOnly = false) => {
    store.dispatch(Actions.showPlaceOrderTermsModal({ isOpen, arOnly }));
};

const toggleCVCInfoModal = parentComp => () => {
    return store.watchAction(TOGGLE_CVC_INFO_MODAL, data => {
        parentComp.setState({ isOpen: data.isOpen });
    });
};

const paymentNumberUpdated = (detectCardTypes, paymentGroupType) => () => {
    return store.watchAction(PAYMENT_CARD_NUMBER_CHANGED, data => {
        const cardTypes = detectCardTypes(data.cardNumber, paymentGroupType);
        store.dispatch(OrderActions.paymentCardsDetected(cardTypes));
    });
};

const CreditCardListToggleCVC = parentComp => () => {
    return store.watchAction(TOGGLE_CVC_INFO_MODAL, data => {
        const actionInfoButton = parentComp.refs.securityCodeInput?.getInfoActionButtonRef();

        if (actionInfoButton && data.isOpen === false) {
            actionInfoButton.focus();
        }
    });
};

//TO-DO: Remove with Rwd - only used in RwdCheckout
function giftCardApplied(parentComp) {
    return () =>
        store.watchAction(GIFT_CARD_APPLIED, () => {
            parentComp.updateOrderDebounce();
        });
}

export default {
    createDraftHalAddress,
    resetAccessPoint,
    changeRoute,
    showPlaceOrderTermsModal,
    toggleCVCInfoModal,
    paymentNumberUpdated,
    CreditCardListToggleCVC,
    giftCardApplied
};
